// extracted by mini-css-extract-plugin
module.exports = {"container":"fg","hero":"gg","content":"hg","typeProd":"ig","notTransparent":"jg","sliderDots":"kg","active":"lg"};